import 'css-chunksrc/client/common/projectSection/averageWeather/styles.scss';export default {
  "weatherReport": "_weatherReport_1irf6_1",
  "iconBox": "_iconBox_1irf6_9",
  "icon": "_icon_1irf6_9",
  "averageScore": "_averageScore_1irf6_21"
};